class AsyncEvent {
	constructor(fn) {
		this._handleSuccess = () => { };
		this._handleFailure = () => { };

		fn.call(this, this._dispatchSuccess.bind(this), this._dispatchFailure.bind(this));
		return this;
	}

	_dispatchSuccess(...args) {
		return this._handleSuccess(...args);
	}

	_dispatchFailure(...args) {
		return this._handleFailure(...args);
	}

	onSuccess(fn) {
		this._handleSuccess = fn;
		return this;
	}

	onFailure(fn) {
		this._handleFailure = fn;
		return this;
	}
}

export default AsyncEvent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/AsyncEvent.js